exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips[data-v-53ce504a] {\n  font-weight: bold;\n}\n.selection-card[data-v-53ce504a] {\n  margin: 0 0.052083rem;\n  padding: 0.125rem;\n  text-align: center;\n  cursor: pointer;\n  position: relative;\n}\n.selection-card[data-v-53ce504a]:hover,\n.selected[data-v-53ce504a] {\n  border-color: rgb(129, 153, 238);\n  color: rgb(48, 87, 228);\n}\n.label[data-v-53ce504a] {\n  font-weight: bold;\n  margin-top: 0.104167rem;\n  font-size: 0.072917rem;\n}\n.selection-btn[data-v-53ce504a] {\n  position: absolute;\n  top: 0.026042rem;\n  left: 0.026042rem;\n}", ""]);

// exports
